// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const NOT_ALL_MESSAGE_PHOTOS_HAVE_BEEN_UPLOADED_SEND_ANYWAY = "E\u0161te nem\u00e1\u0161 nahran\u00e9 v\u0161etky fotky. Chce\u0161 pr\u00edspevok odosla\u0165 bez nich?";
